import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeoLiveStatusForm } from 'src/components/peo';
import { usePeoParamId } from 'src/hooks/peo';

import { NotFoundErrorPage } from '../not-found';

export const PeoDetailLiveStatusPage: React.FC = () => {
  const peoId = usePeoParamId();

  return (
    <DetailPageLayout titleContent='Settings / "Is Live" Status'>
      {peoId ? <PeoLiveStatusForm peoId={peoId} /> : <NotFoundErrorPage />}
    </DetailPageLayout>
  );
};
